<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.candidates')"
      filterable
      clearable
      :size="size"
      class="d-block"
      :multiple="multiple"
      :class="mode ? 'input__day' : 'input__night'"
    >
      <el-option
        v-for="(candidate, index) in candidates"
        :key="'candidate-' + index"
        :label="
          candidate.name + ' ' + candidate.last_name ? candidate.last_name : ''
        "
        :value="candidate.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,      
    },
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    if (this.candidates && this.candidates.length === 0){
        this.fetchCandidates();        
    }
  },
  computed: {
    ...mapGetters({
      candidates: "candidate/inventory",
      mode:'MODE'
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "candidate/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
    fetchCandidates() {
      const query = { ...this.filter };
      this.updateInventory(query)
        .then((res) => {          
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
  },
};
</script>
